/** ID estável em HTTP (rede local) e HTTPS. `crypto.randomUUID` só existe em contexto seguro. */
export function createId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`
}
